import { Spin } from 'antd'
import React from 'react'
import { StyledDHSManualUpdateLoadingContainer } from './DHSManualUpdate.styled'

export const DHSManualUpdateLoading: React.FC = () => {
  return (
    <StyledDHSManualUpdateLoadingContainer>
      <Spin size="large" tip="Loading DHS Manual Update...">
        <div style={{ padding: 50 }} />
      </Spin>
    </StyledDHSManualUpdateLoadingContainer>
  )
}
